import {AxiosError} from "axios";

export function logApiError(method: string, url: string, error: Error | AxiosError) {
    // eslint-disable-next-line
    console.error(`request rejected: ${method} ${url} with error ${error}`);
}
